/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Channel_Reply_ValueInputs */

const en_contact_channel_reply_value = /** @type {(inputs: Contact_Channel_Reply_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Within one working day`)
};

const lv_contact_channel_reply_value = /** @type {(inputs: Contact_Channel_Reply_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vienas darba dienas laikā`)
};

/**
* | output |
* | --- |
* | "Within one working day" |
*
* @param {Contact_Channel_Reply_ValueInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_channel_reply_value = /** @type {((inputs?: Contact_Channel_Reply_ValueInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Channel_Reply_ValueInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_channel_reply_value(inputs)
	return en_contact_channel_reply_value(inputs)
});